import { useState, useEffect } from 'react';

const STORAGE_KEY = 'cpay-client-theme';

export function applyTheme(preference) {
    const isDark =
        preference === 'dark' ||
        (preference === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', isDark);
}

export function useTheme() {
    const [theme, setThemeState] = useState(
        () => localStorage.getItem(STORAGE_KEY) || 'system'
    );

    const setTheme = (value) => {
        localStorage.setItem(STORAGE_KEY, value);
        setThemeState(value);
        applyTheme(value);
    };

    useEffect(() => {
        applyTheme(theme);

        if (theme === 'system') {
            const mq = window.matchMedia('(prefers-color-scheme: dark)');
            const handler = () => applyTheme('system');
            mq.addEventListener('change', handler);
            return () => mq.removeEventListener('change', handler);
        }
    }, [theme]);

    return { theme, setTheme };
}
